import { render, staticRenderFns } from "./ChevronUpIcon.vue?vue&type=template&id=2cf7028c"
import script from "./ChevronUpIcon.vue?vue&type=script&lang=js"
export * from "./ChevronUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports